import React, {useMemo} from "react";
import {Location, locationTypeOptions} from "../location/KeyLocationShield";
import {mapSetState, selectChangeEvent, SetState} from "../../util/FormHandlers";
import {Checkbox, FormControl, Grid, InputLabel, ListItemText, MenuItem, Select} from "@mui/material";
import {ar} from "cronstrue/dist/i18n/locales/ar";

export function LocationFilter<Filter extends { location: Location[] }>({filter, setFilter}: {
    filter: Filter,
    setFilter: SetState<Filter>,
}) {
    const setLocation = useMemo(
        () => mapSetState(setFilter, 'location'),
        [setFilter],
    );
    const handleChange = useMemo(
        () => selectChangeEvent<Location[]>(value => {
            const arrayValue = typeof value === 'string' ? value.split(',') as Location[] : value
            setLocation(arrayValue.filter(location => locationTypeOptions[location]));
        }),
        [setLocation],
    );

    return (
        <Grid size={{lg: 2, md: 3, xs: 12}}>
            <FormControl fullWidth variant="outlined">
                <InputLabel id="location-label" shrink>Location</InputLabel>
                <Select<Location[]>
                    labelId="location-label"
                    value={filter.location}
                    onChange={handleChange}
                    label="Location"
                    multiple
                    displayEmpty
                    renderValue={selected => selected.length === 0
                        ? 'All Locations'
                        : selected.map(location => locationTypeOptions[location]?.label ?? location).join(', ')}
                >
                    {Object.entries(locationTypeOptions)
                        .map(([locationType, option]) => ({
                            value: locationType as Location,
                            label: `${option.emoji}  ${option.label}`,
                        }))
                        .map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                <Checkbox checked={filter.location.includes(option.value)}/>
                                <ListItemText primary={option.label}/>
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        </Grid>
    );
}
